module.exports = __webpack_public_path__ + "59cb74e38c18c8643795375e7f7e0330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/pic2.png
// module id = 1861
// module chunks = 0